import { render } from "./item-view.vue?vue&type=template&id=09e68620"
import script from "./item-view.vue?vue&type=script&lang=js"
export * from "./item-view.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__